/******************************************************************
 * Archivo : client/src/components/Admin/users/UserForm.js
 * Proyecto: CB30
 *
 * Formulario de Administración de Usuarios
 ******************************************************************/

import React from "react";
import { Link } from "react-router-dom";

const UserForm = ({
  user = {},
  roles = [],
  onChange,
  onSubmit,
  isNewUser = false
}) => {

  return (

    <div className="container">

      <div className="row justify-content-center">

        <div className="col-lg-8">

          <div className="card shadow-sm">

            <div className="card-header bg-white">

              <h3 className="mb-1">
  {
    isNewUser
      ? "Nuevo Usuario"
      : "Editar Usuario"
  }
</h3>

<small className="text-muted">
  {
    isNewUser
      ? "Cree un nuevo usuario, asigne su rol inicial y defina sus datos de acceso."
      : "Modifique la información, el rol o el estado del usuario seleccionado."
  }
</small>

            </div>

            <div className="card-body">

              <form onSubmit={onSubmit}>

                <div className="form-group">

                  <label>Email</label>

                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={user.email || ""}
                    onChange={onChange}
                  />

                </div>

                <div className="form-row">

                  <div className="form-group col-md-6">

                    <label>Nombre</label>

                    <input
                      type="text"
                      className="form-control"
                      name="nombre"
                      value={user.nombre || ""}
                      onChange={onChange}
                    />

                  </div>

                  <div className="form-group col-md-6">

                    <label>Apellido</label>

                    <input
                      type="text"
                      className="form-control"
                      name="apellido"
                      value={user.apellido || ""}
                      onChange={onChange}
                    />

                  </div>

                </div>

                {
                  isNewUser && (

                  <div className="form-group">

                  <label>Contraseña Temporal</label>

                  <input
                    type="password"
                    className="form-control"
                    name="password"
                    value={user.password || ""}
                    onChange={onChange}
                      />

                    <div className="mt-3">

                      <label>Confirmar Contraseña</label>

                      <input
                        type="password"
                        className="form-control"
                        name="confirmPassword"
                        value={user.confirmPassword || ""}
                        onChange={onChange}
                      />

                    </div>

                    </div>

  )
}

                <div className="form-row">

                  <div className="form-group col-md-6">

                    <label>Rol</label>

                    <select
                      className="form-control"
                      name="roleId"
                      value={user.roleId || ""}
                      onChange={onChange}
                    >

                      <option value="">
                        Seleccione...
                      </option>

                      {roles.map(role => (

                        <option
                          key={role.id}
                          value={role.id}
                        >
                          {role.label}
                        </option>

                      ))}

                    </select>

                  </div>

                  <div className="form-group col-md-6">

                    <label>Tipo Perfil</label>

                    <select
                      className="form-control"
                      name="tipoPerfil"
                      value={user.tipoPerfil || 0}
                      onChange={onChange}
                    >

                      <option value={0}>0</option>
                      <option value={1}>1</option>
                      <option value={2}>2</option>
                      <option value={3}>3</option>
                      <option value={4}>4</option>
                      <option value={5}>5</option>

                    </select>

                  </div>

                </div>

                <div className="form-row">

                  <div className="form-group col-md-6">

                    <div className="custom-control custom-switch">

                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="active"
                        name="active"
                        checked={user.active || false}
                        onChange={onChange}
                      />

                      <label
                        className="custom-control-label"
                        htmlFor="active"
                      >
                        Activo
                      </label>

                    </div>

                  </div>

                  <div className="form-group col-md-6">

                    <div className="custom-control custom-switch">

                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="validated"
                        name="validated"
                        checked={user.validated || false}
                        onChange={onChange}
                      />

                      <label
                        className="custom-control-label"
                        htmlFor="validated"
                      >
                        Validado
                      </label>

                    </div>

                  </div>

                </div>

                <div className="mt-4 d-flex justify-content-between">

                  <Link
                    to="/admin/usuarios"
                    className="btn btn-outline-secondary"
                  >
                    Cancelar
                  </Link>

                  <button
                    type="submit"
                    className="btn btn-primary"
                  >
                    {
                      isNewUser
                      ? "Crear Usuario"
                      : "Guardar Cambios"
                    }
                  </button>

                </div>

              </form>

            </div>

          </div>

        </div>

      </div>

    </div>

  );

};

export default UserForm;


// WEBPACK FOOTER //
// ./src/components/Admin/users/UserForm.js